'use strict';

var _slicedToArray = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var car = require('@ipld/car');

var block = require('multiformats/block');

var raw = require('multiformats/codecs/raw');

var dagCbor = require('@ipld/dag-cbor');

var pb = require('@ipld/dag-pb');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var raw__namespace = /*#__PURE__*/_interopNamespace(raw);

var dagCbor__namespace = /*#__PURE__*/_interopNamespace(dagCbor);

var pb__namespace = /*#__PURE__*/_interopNamespace(pb);

var TreewalkCarSplitter = /*#__PURE__*/function () {
  function TreewalkCarSplitter(reader, targetSize) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, TreewalkCarSplitter);

    if (typeof targetSize !== 'number' || targetSize <= 0) {
      throw new Error('invalid target chunk size');
    }

    this._reader = reader;
    this._targetSize = targetSize;
    this._decoders = [pb__namespace, raw__namespace, dagCbor__namespace].concat(_toConsumableArray(options.decoders || []));
  }

  _createClass(TreewalkCarSplitter, [{
    key: "cars",
    value: function cars() {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var roots, channel, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, val;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _awaitAsyncGenerator(_this._reader.getRoots());

              case 2:
                roots = _context.sent;

                if (!(roots.length !== 1)) {
                  _context.next = 5;
                  break;
                }

                throw new Error("unexpected number of roots: ".concat(roots.length));

              case 5:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 7;
                _iterator = _asyncIterator(_this._cars(roots[0]));

              case 9:
                _context.next = 11;
                return _awaitAsyncGenerator(_iterator.next());

              case 11:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 20;
                  break;
                }

                val = _step.value;
                channel = val.channel;

                if (!val.out) {
                  _context.next = 17;
                  break;
                }

                _context.next = 17;
                return val.out;

              case 17:
                _iteratorAbruptCompletion = false;
                _context.next = 9;
                break;

              case 20:
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 31;
                  break;
                }

                _context.next = 31;
                return _awaitAsyncGenerator(_iterator.return());

              case 31:
                _context.prev = 31;

                if (!_didIteratorError) {
                  _context.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context.finish(31);

              case 35:
                return _context.finish(26);

              case 36:
                if (channel) {
                  _context.next = 38;
                  break;
                }

                throw new Error('missing CAR writer channel');

              case 38:
                channel.writer.close();
                _context.next = 41;
                return channel.out;

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 22, 26, 36], [27,, 31, 35]]);
      }))();
    }
  }, {
    key: "_get",
    value: function () {
      var _get2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid) {
        var rawBlock, bytes, decoder;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._reader.get(cid);

              case 2:
                rawBlock = _context2.sent;

                if (rawBlock) {
                  _context2.next = 5;
                  break;
                }

                throw new Error("missing block for ".concat(cid));

              case 5:
                bytes = rawBlock.bytes;
                decoder = this._decoders.find(function (d) {
                  return d.code === cid.code;
                });

                if (decoder) {
                  _context2.next = 9;
                  break;
                }

                throw new Error("missing decoder for ".concat(cid.code));

              case 9:
                return _context2.abrupt("return", new block.Block({
                  cid: cid,
                  bytes: bytes,
                  value: decoder.decode(bytes)
                }));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _get(_x) {
        return _get2.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_cars",
    value: function _cars(cid) {
      var _this2 = this;

      var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var channel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var block, _channel, out, _iterator3, _step3, _step3$value, _cid, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, val;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _awaitAsyncGenerator(_this2._get(cid));

              case 2:
                block = _context3.sent;
                channel = channel || Object.assign(car.CarWriter.create(cid), {
                  size: 0
                });

                if (!(channel.size > 0 && channel.size + block.bytes.byteLength >= _this2._targetSize)) {
                  _context3.next = 10;
                  break;
                }

                channel.writer.close();
                _channel = channel, out = _channel.out;
                channel = newCar(parents);
                _context3.next = 10;
                return {
                  channel: channel,
                  out: out
                };

              case 10:
                parents = parents.concat(block);
                channel.size += block.bytes.byteLength;
                channel.writer.put(block);
                _iterator3 = _createForOfIteratorHelper(block.links());
                _context3.prev = 14;

                _iterator3.s();

              case 16:
                if ((_step3 = _iterator3.n()).done) {
                  _context3.next = 50;
                  break;
                }

                _step3$value = _slicedToArray(_step3.value, 2), _cid = _step3$value[1];
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context3.prev = 20;
                _iterator2 = _asyncIterator(_this2._cars(_cid, parents, channel));

              case 22:
                _context3.next = 24;
                return _awaitAsyncGenerator(_iterator2.next());

              case 24:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context3.sent).done)) {
                  _context3.next = 32;
                  break;
                }

                val = _step2.value;
                channel = val.channel;
                _context3.next = 29;
                return val;

              case 29:
                _iteratorAbruptCompletion2 = false;
                _context3.next = 22;
                break;

              case 32:
                _context3.next = 38;
                break;

              case 34:
                _context3.prev = 34;
                _context3.t0 = _context3["catch"](20);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 38:
                _context3.prev = 38;
                _context3.prev = 39;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context3.next = 43;
                  break;
                }

                _context3.next = 43;
                return _awaitAsyncGenerator(_iterator2.return());

              case 43:
                _context3.prev = 43;

                if (!_didIteratorError2) {
                  _context3.next = 46;
                  break;
                }

                throw _iteratorError2;

              case 46:
                return _context3.finish(43);

              case 47:
                return _context3.finish(38);

              case 48:
                _context3.next = 16;
                break;

              case 50:
                _context3.next = 55;
                break;

              case 52:
                _context3.prev = 52;
                _context3.t1 = _context3["catch"](14);

                _iterator3.e(_context3.t1);

              case 55:
                _context3.prev = 55;

                _iterator3.f();

                return _context3.finish(55);

              case 58:
                if (channel) {
                  _context3.next = 60;
                  break;
                }

                throw new Error('missing CAR writer channel');

              case 60:
                _context3.next = 62;
                return {
                  channel: channel
                };

              case 62:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[14, 52, 55, 58], [20, 34, 38, 48], [39,, 43, 47]]);
      }))();
    }
  }], [{
    key: "fromIterable",
    value: function () {
      var _fromIterable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(iterable, targetSize, options) {
        var reader;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return car.CarReader.fromIterable(iterable);

              case 2:
                reader = _context4.sent;
                return _context4.abrupt("return", new TreewalkCarSplitter(reader, targetSize, options));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function fromIterable(_x2, _x3, _x4) {
        return _fromIterable.apply(this, arguments);
      }

      return fromIterable;
    }()
  }, {
    key: "fromBlob",
    value: function () {
      var _fromBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(blob, targetSize, options) {
        var buffer, reader;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return blob.arrayBuffer();

              case 2:
                buffer = _context5.sent;
                _context5.next = 5;
                return car.CarReader.fromBytes(new Uint8Array(buffer));

              case 5:
                reader = _context5.sent;
                return _context5.abrupt("return", new TreewalkCarSplitter(reader, targetSize, options));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function fromBlob(_x5, _x6, _x7) {
        return _fromBlob.apply(this, arguments);
      }

      return fromBlob;
    }()
  }]);

  return TreewalkCarSplitter;
}();

function newCar(parents) {
  var ch = Object.assign(car.CarWriter.create(parents[0].cid), {
    size: parents.reduce(function (size, b) {
      return size + b.bytes.byteLength;
    }, 0)
  });

  var _iterator4 = _createForOfIteratorHelper(parents),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var b = _step4.value;
      ch.writer.put(b);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return ch;
}

exports.TreewalkCarSplitter = TreewalkCarSplitter;